<template>
  <ValidationObserver ref="requestPasswordFormValidator">
    <form
      @submit.prevent="submitForgotPassword"
      data-qa="request-password--form"
    >
      <Input
        id="code"
        validation-rules="required|numeric|code"
        :input-model.sync="code"
        :label-text="$t('requestPasswordForm_code_label')"
        :placeholder-text="$t('requestPassword_placeholder_input')"
        input-type="tel"
        :error-text="`${$t('requestPasswordForm_emptyCode_text')}.`"
        class="por-request-password--field-wrapper"
        data-qa="por-request-password--code-input" />
      <Input
        id="email"
        validation-rules="required|email"
        :input-model.sync="email"
        :label-text="$t('common_email_label')"
        :placeholder-text="$t('common_email_placeholder')"
        input-type="email"
        :error-text="`${$t('common_validEmail_text')}.`"
        class="por-request-password--field-wrapper"
        data-qa="por-request-password--email-input" />
      <Password
        id="password"
        :input-model.sync="password"
        :label-text="$t('common_newPassword_text')"
        placeholder-text="••••••••"
        :error-text="`${$t('common_validPassword_text')}.`"
        class="por-request-password--field-wrapper"
        data-qa="por-request-password--password-component" />
      <b-button
        class="por-request-password--button"
        size="is-medium"
        type="is-primary"
        expanded
        :disabled="isSubmitting || submitStatus === 'SUCCESS'"
        :loading="isSubmitting"
        tag="input"
        native-type="submit"
        :value="$t('requestPassword_resetPassword_text')"
        data-qa="por-request-password--submit-button" />
    </form>
  </ValidationObserver>
</template>

<script>
import { Auth } from '@aws-amplify/auth'

import { mapGetters } from 'vuex'

import Input from '@/components/inputs/input'
import Password from '@/components/inputs/password'

import { redirect } from '@/services/redirect'
import { track, identify } from '@/services/tracking'
import { errorMessageMapping } from '@/helpers/message-mapping'
import trackErrors from '@/helpers/track-errors'

export default {
  name: 'RequestPasswordForm',
  components: {
    Input,
    Password
  },
  data () {
    return {
      code: '',
      email: '',
      password: '',
      showPasswordErrorText: false,
      submitStatus: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/userCredentials'
    }),
    validEmail: function () {
      return this.email.toLowerCase()
    },
    isSubmitting: function () {
      return this.submitStatus === 'PENDING'
    }
  },
  methods: {
    async submitForgotPassword () {
      track({ name: 'button tap', params: { module: 'reset password', description: 'reset password button' } })

      this.submitStatus = 'PENDING'

      this.$refs.requestPasswordFormValidator.validate().then(async success => {
        if (!success) {
          this.submitStatus = null
          trackErrors(this.$refs.requestPasswordFormValidator, 'reset password')
          this.showPasswordErrorText = true

          return
        }

        try {
          await Auth.forgotPasswordSubmit(this.validEmail, this.code, this.password)

          track({ name: 'reset password success', params: { module: 'reset password' } })

          if (window.newrelic) {
            window.newrelic.addPageAction('requestpassword')
          }

          this.cognitoResponse = await Auth.signIn(this.validEmail, this.password)

          track({ name: 'login success', params: { module: 'reset password' } })

          let newUser = await Auth.currentSession()
          let patientId = newUser.getIdToken().decodePayload().patient_id

          identify(patientId, { email: this.validEmail })

          this.submitStatus = 'OK'

          redirect()
        } catch (error) {
          let errorMessage = errorMessageMapping(error.message)
          this.$store.dispatch('site/setMessage', { message: errorMessage, type: 'danger' })
          track({ name: 'error', params: { module: 'reset password', error_message: errorMessage } })

          this.submitStatus = null
        }
      })
    }
  },
  created () {
    if (this.user.email) {
      this.email = this.user.email
    }
  }
}
</script>
<style lang="scss" scoped>
  $por-request-margin-top: 16px;

  .por-request-password--button,
  .por-request-password--field-wrapper + .por-request-password--field-wrapper {
    display: block;
    margin-top: $por-request-margin-top;
  }
</style>
